import type { HTMLAttributes } from 'react'
import { createElement } from 'react'

export const RoomContainer = (props: HTMLAttributes<HTMLDivElement>) =>
  createElement('div', { ...props, style: { height: '100%', display: 'flex', ...props.style } })

export const VideoGrid = (props: HTMLAttributes<HTMLDivElement>) =>
  createElement('div', {
    ...props,
    style: {
      height: '50%',
      flex: 2,
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      paddingLeft: 4,
      paddingRight: 4,
      ...props.style,
    },
  })

export const GridItem = (props: HTMLAttributes<HTMLDivElement>) =>
  createElement('div', {
    ...props,
    style: {
      display: 'flex',
      flex: 1,
      height: '100%',
      overflow: 'hidden',
      alignItems: 'center',
      justifyContent: 'center',
      ...props.style,
    },
  })

export const EntitiesContainer = (props: HTMLAttributes<HTMLDivElement>) =>
  createElement('div', { ...props, style: { overflowY: 'auto', ...props.style } })

export const StreamContainer = (props: HTMLAttributes<HTMLDivElement>) =>
  createElement('div', {
    ...props,
    style: { height: '100%', alignItems: 'center', justifyContent: 'center', padding: 4, ...props.style },
  })

export const TextElement = (props: HTMLAttributes<HTMLDivElement>) =>
  createElement('div', { ...props, style: { top: 8, paddingBottom: 16, ...props.style } })

export const ContentContainer = (props: HTMLAttributes<HTMLDivElement>) =>
  createElement('div', {
    ...props,
    style: { display: 'flex', flex: 1, height: '100%', alignItems: 'center', overflow: 'hidden', ...props.style },
  })

export const Sidebar = (props: HTMLAttributes<HTMLDivElement>) =>
  createElement('div', { ...props, style: { maxWidth: 300, position: 'relative', ...props.style } })

export const ControlsOverlay = (props: HTMLAttributes<HTMLDivElement>) =>
  createElement('div', {
    ...props,
    style: {
      background: 'transparent',
      opacity: 0.9,
      width: 300,
      position: 'fixed',
      right: 0,
      bottom: 40,
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      ...props.style,
    },
  })

export const PlayIcon = (props: HTMLAttributes<HTMLDivElement>) =>
  createElement('div', { ...props, style: { width: '4em', height: '4em', ...props.style } })

export const PlayButton = (props: HTMLAttributes<HTMLButtonElement>) =>
  createElement('button', { ...props })
